import { CenteredBox, H2 } from '../../widgets'

export const TextScreen = ({ text, color, background, mt, ...props }) => (
  <CenteredBox
    position="absolute"
    fullWidth
    fullHeight
    color={color}
    background={background}
    {...props}
  >
    <H2 style={{ transform: 'translateY(100px)', opacity: 0 }} mt={mt}>
      {text}
    </H2>
  </CenteredBox>
)

